<template>
	<div
		:class="['c-block', { selected: selected === true }, { focus: focus }]"
		:data-id="block._id"
		:data-acceptdrop="acceptDrop"
	>
		<div
			class="c-block__dragger"
			@mousedown="onDraggerClick"
			@mouseup="onDraggerMouseUp"
			@mouseleave="onDraggerMouseUp"
		>
			<div class="c-block__dragger__btn">
				<more-vertical-icon size="1x"></more-vertical-icon>
				<more-vertical-icon size="1x"></more-vertical-icon>
			</div>
		</div>
		<div
			class="c-block__menu"
			@click="openLink"
			v-if="block.source && block.source.url"
		>
			<external-link-icon size="1x"></external-link-icon>
		</div>
		<div class="c-block__inner">
			<ImageBlock :block="block" v-if="block.type === 'image'"></ImageBlock>
			<TextBlock
				:block="block"
				v-if="block.type === 'text'"
				@update="onUpdate"
				@focus="updateFocus"
				@createBlock="onCreateBlock"
				:fakeBlock="fakeBlock"
			></TextBlock>
			<FolderBlock
				:block="block"
				v-if="block.type === 'folder'"
				@update="onUpdate"
			></FolderBlock>
		</div>
	</div>
</template>

<script>
import ImageBlock from '@/components/dashboard/image-block';
import TextBlock from '@/components/dashboard/text-block';
import FolderBlock from '@/components/dashboard/folder-block';

import { MoreVerticalIcon, ExternalLinkIcon } from 'vue-feather-icons';

export default {
	components: {
		ImageBlock,
		TextBlock,
		FolderBlock,
		MoreVerticalIcon,
		ExternalLinkIcon,
	},

	data: function () {
		return {
			focus: false,
			timer: null,
		};
	},

	props: {
		blockData: {
			type: Object,
		},
		fakeBlock: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		selected: function () {
			return this.blockData.selected;
		},
		block: function () {
			return this.blockData.block;
		},
		acceptDrop: function () {
			if (this.block.type === 'folder') {
				return true;
			} else {
				return false;
			}
		},
	},

	methods: {
		onCreateBlock: function (content) {
			this.$emit('createBlock', content);
		},
		// this.focus is not actual focus, it only tells this block that the child text-block has focus and therefore update this view appriopriately
		updateFocus: function (focusState) {
			this.focus = focusState;
		},
		onDraggerClick: function () {
			this.timer = setTimeout(() => {
				this.$emit('dragstart', this.block._id);
			}, 60);
		},
		onDraggerMouseUp: function () {
			clearTimeout(this.timer);
		},
		openLink: function () {
			window.open(this.block.source.url, '_blank').focus();
		},
		onUpdate: function (block) {
			this.$store.dispatch('block/updateTextBlock', block);
		},
	},
	mounted: function () {
		setTimeout(() => {
			this.active = true;
		}, 10);
	},
};
</script>

<style lang="scss" scoped>
.c-block {
	position: relative;
	padding: 0;

	&:before {
		content: '';
		position: absolute;
		z-index: -1;
		top: 1px;
		left: 0;
		width: 100%;
		height: calc(100% - 2px);
		background-color: rgba(var(--p-r), var(--p-g), var(--p-b), 0.5);
		opacity: 0;
		transition: opacity var(--transition-time-sm) ease-out;
	}

	&:after {
		content: '';
		position: absolute;
		z-index: -1;
		top: 1px;
		left: 0;
		width: 100%;
		height: calc(100% - 2px);
		background-color: rgba(0, 0, 0, 0.15);
		opacity: 0;
		transition: opacity var(--transition-time-sm) ease-out;

		[data-theme='pristina'] & {
			background-color: rgba(0, 0, 0, 0.025);
		}
	}

	&.selected {
		&:before {
			opacity: 1;
		}
		.c-block__inner {
			opacity: 0.75;
		}
	}

	&__dragger {
		position: absolute;
		top: 0px;
		left: -24px;
		display: flex;
		justify-content: center;
		align-items: flex-end;
		width: 24px;
		height: 21px;
		color: rgba(255, 255, 255, 0.4);
		border-radius: var(--border-radius);
		background-color: transparent;
		cursor: grab;
		opacity: 0;
		transition: all 120ms ease-out;

		&__btn {
			position: relative;
			width: 16px;
			height: 20px;
			background-color: transparent;
			border-radius: var(--border-radius);
			transition: all var(--transition-time) ease-out var(--transition-time-sm);
		}

		svg {
			position: absolute;
			top: 2px;
			left: -3px;
			color: var(--font-color);
			&:last-child {
				margin-left: 6px;
			}
		}

		&:active {
			.c-block__dragger__btn {
				transform: scale(1.3);
				background-color: var(--g2);
			}
		}
	}

	&__menu {
		position: absolute;
		top: var(--margin-lg);
		right: -26px;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 20px;
		height: 20px;
		color: rgba(255, 255, 255, 0.4);
		border-radius: var(--border-radius);
		background-color: transparent;
		cursor: pointer;
		opacity: 0;
		transition: all 120ms ease-out;
	}

	&.focus {
		.c-block__dragger {
			opacity: 1;
		}
		&:after {
			opacity: 1;
		}
	}

	&:hover {
		.c-block__dragger {
			opacity: 0.75;
		}
		.c-block__menu {
			opacity: 0.75;
		}
	}

	.c-renderer.moving & {
		&:after {
			opacity: 1;
		}
	}
}
</style>